var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "inherit",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.44 6.227 8.5 9.28l3.06-3.053.94.94-4 4-4-4z"
})));
export default SvgCaretDown;